<template>
  <li class="flex items-center px-4 py-2 hover:bg-gray-200 group">
    <span class="w-3/12">
      {{ displayName }}
    </span>

    <span class="w-2/12">
      {{ generationService }}
    </span>

    <div class="w-6/12">
      <span v-if="brandEasyConfig">
        {{ brandEasyConfig.template }} |
        {{ brandEasyConfig.target }}
        <span v-if="brandEasyConfig.target === 'print'">
          | {{ brandEasyConfig.bleed }}
        </span>
      </span>

      <span v-if="creatifyConfig">
        {{ creatifyConfig.templateId }} |
        {{ creatifyConfig.variants.map(({variant, templateId}) => `${variant}: ${templateId}`).join(', ') }}
      </span>

      <span v-if="staticConfig">
        <a
          target="_blank"
          :href="staticConfig.file.cdnUrl"
        >{{ staticConfig.file.name }}</a>
        | {{ staticConfig.variants.join(', ') }}
      </span>
    </div>

    <div class="flex justify-end w-1/12 space-x-1">
      <button
        class="opacity-25 hover:text-green-600 btn-icon hover:opacity-100"
        :title="$t('components.materialTemplate.addToLandingpagesTitle')"
        @click="createMaterialsForTemplate()"
      >
        <fa
          :icon="faPlus"
          fixed-width
        />
      </button>
      <button
        class="opacity-25 hover:text-green-600 btn-icon hover:opacity-100"
        :title="$t('components.materialTemplate.generateTitle')"
        @click="generateMaterialsForTemplate()"
      >
        <fa
          :icon="faGear"
          fixed-width
        />
      </button>
      <button
        class="opacity-25 hover:text-red-600 btn-icon hover:opacity-100"
        :title="$t('components.materialTemplate.deleteTitle')"
        @click="deleteMaterialTemplate()"
      >
        <fa
          :icon="faTrash"
          fixed-width
        />
      </button>
    </div>
  </li>
</template>

<script>
import { faTrash, faPlus, faGear } from '@fortawesome/free-solid-svg-icons'
import DELETE from '@/graphql/DeleteMaterialTemplateWithRelatedMaterials.gql'
import CREATE from '@/graphql/CreateMaterialsForMaterialTemplate.gql'
import GENERATE from '@/graphql/GenerateMaterialsForTemplate.gql'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    displayName: {
      type: String,
      required: true
    },
    generationService: {
      type: String,
      required: true
    },
    brandEasyConfig: {
      type: Object,
      default: () => {}
    },
    creatifyConfig: {
      type: Object,
      default: () => ({})
    },
    staticConfig: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      faTrash,
      faPlus,
      faGear
    }
  },

  methods: {
    async createMaterialsForTemplate () {
      const hasConfirmed = confirm(this.$t('components.materialTemplate.addToLandingpagesConfirm', { name: this.displayName }))

      if (hasConfirmed) {
        try {
          await this.$apollo.mutate({
            mutation: CREATE,
            variables: {
              materialTemplateId: this.id
            }
          })

          alert(this.$t('components.materialTemplate.addToLandingpagesSuccess'))
        } catch (err) {
          alert(this.$t('components.materialTemplate.addToLandingpagesFailed', { error: err.message }))
        }
      }
    },
    async generateMaterialsForTemplate () {
      const hasConfirmed = confirm(this.$t('components.materialTemplate.generateConfirm', { name: this.displayName }))

      if (hasConfirmed) {
        try {
          const { data: { result } } = await this.$apollo.mutate({
            mutation: GENERATE,
            variables: {
              input: { materialTemplateId: this.id }
            }
          })
          alert(this.$t('components.materialTemplate.generateSuccess', { count: result }))
        } catch (err) {
          alert(this.$t('components.materialTemplate.generateFailed', { error: err.message }))
        }
      }
    },
    async deleteMaterialTemplate () {
      const hasConfirmed = confirm(this.$t('components.materialTemplate.deleteConfirm', { name: this.displayName }))

      if (hasConfirmed) {
        try {
          const { data } = await this.$apollo.mutate({
            mutation: DELETE,
            variables: {
              materialTemplateId: this.id
            },
            update: (cache, { data: { result } }) => {
              this.$emit('deleted', result)
            }
          })

          alert(this.$t('components.materialTemplate.deleteSuccess', { count: data.result.deletedMaterialsCount }))
        } catch (err) {
          alert(this.$t('components.materialTemplate.deleteFailed', { error: err.message }))
        }
      }
    }
  }
}
</script>
